import * as React from 'react';
import Form from 'apmui/components/form/View';
import { IOktaMfaModel, FIELD_YUBICO } from './Model';
import { IFormField, INPUT } from 'apmui/components/form/Model';

interface IYubicoVerifyProps {
    okta: IOktaMfaModel;
}

class YubicoVerify extends React.Component<IYubicoVerifyProps> {
    componentDidMount() {
        document.getElementsByName(FIELD_YUBICO)[0].focus();
    }

    render() {
        const { strings, form } = this.props.okta.oktaMfa;
        if (form.fields.length == 0) {
            const yubicoField: IFormField = {
                name: FIELD_YUBICO,
                type: INPUT.PASSWORD,
                caption: '',
                disabled: false,
                value: undefined,
            };
            form.fields.push(yubicoField);
        }
        const yubicoSubmit = (
            <span className="button-container">
                <input
                    type="submit"
                    className="apmui-button apmui-button-submit apmui-button-long"
                    id="yubico_otp.submit"
                    value={strings.verify}
                />
            </span>
        );
        const yubicoVerify = (
            <div>
                <p>{strings.yubicoOtpMsg}</p>
                <Form {...form}>
                    <br />
                    {yubicoSubmit}
                </Form>
            </div>
        );
        return <div>{yubicoVerify}</div>;
    }
}

export default YubicoVerify;
